
       
       <div class="row">
 
 
 <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
     
    <table style=" height: 100px!important;width: 100%;"  mat-table [dataSource]="dataSource" matSort matSortActive="id" 
    matSortDirection="desc" matSortDisableClear>


    <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
        <td mat-cell *matCellDef="let facturedetail">
<span style="background-color: yellow;" *ngIf="facturedetail.produit.specifique">{{facturedetail.designation}}</span>
<span *ngIf="!facturedetail.produit.specifique">{{facturedetail.designation}}</span>
            
        
        
        </td>
    </ng-container>
    <ng-container matColumnDef="quantite">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Qnt</th>
        <td mat-cell *matCellDef="let facturedetail">

            {{facturedetail.quantite}}</td>
    </ng-container>
    <ng-container matColumnDef="prixunit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Prix</th>
        <td mat-cell *matCellDef="let facturedetail">

            {{facturedetail.prixunit}} </td>
    </ng-container>

    <ng-container matColumnDef="stotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>S.Total</th>
        <td mat-cell *matCellDef="let facturedetail">

            <span style="color: #05164D;">
                    &nbsp;&nbsp;&nbsp;&nbsp;{{facturedetail.prixunit*facturedetail.quantite}}
            </span>
        </td>
    </ng-container>
    <ng-container matColumnDef="remise">
        <th mat-header-cell *matHeaderCellDef style="width: 100px">Remise </th>
        <td mat-cell *matCellDef="let facturedetail">
  {{facturedetail.remise| currency: ' '}} 
        </td>
      </ng-container>

      <ng-container matColumnDef="nfacture">
        <th mat-header-cell *matHeaderCellDef  >Remise </th>
        <td mat-cell *matCellDef="let facturedetail">
<span style="background-color: red;color: white;" *ngIf="facturedetail.idfacture.numeroFiche"> Facture validé:  {{facturedetail.idfacture.numeroFiche }} </span>
<span *ngIf="!facturedetail.idfacture.numeroFiche"> Facture non validé:  {{facturedetail.idfacture.idfacture }} </span>
            
        </td>
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;"></tr>

</table>
 </div>
 
 <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
    <app-facture-list></app-facture-list>
 </div>
 
     

  
 
 




</div>